module.exports = __webpack_public_path__ + "static/media/h4p_top_02.3d6ac949.gif";